import { compact, map } from "lodash";

export interface SandboxGrammarHighlight {
  originalText?: string;
  correctedText?: string;
  explanation?: string;
}

// 🔴 The contract gives no shape for `highlighted_errors`; these names are a guess, and unknown items are skipped.
export const grammarHighlights = (errors: unknown[]): SandboxGrammarHighlight[] =>
  compact(
    map(errors, (error) => {
      const item = error as Record<string, unknown>;
      const text = (key: string) => (typeof item?.[key] === "string" ? (item[key] as string) : undefined);
      const highlight = {
        originalText: text("original_text") ?? text("originalText"),
        correctedText: text("corrected_text") ?? text("correctedText"),
        explanation: text("explanation"),
      };

      return highlight.originalText || highlight.correctedText || highlight.explanation ? highlight : undefined;
    })
  );
